import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { AppointmentTypeService } from "./appointment-type.service";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { IAppointmentType } from "./iappointment-type";

@Injectable({
    providedIn: 'root'
})
export class AppointmentTypeResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _appointmentTypeService: AppointmentTypeService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, appointments: IAppointmentType[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._appointmentTypeService.getAppointmentType(data);
    }
}